/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { addCountryPayoutConfig } from '../../config/addCountry.config';

export interface IAddCountryPluginMethods extends IPluginMethodMap {
  getAddCountrySync(args?: any): any;
}

export class AddCountryPlugin implements IAgentPlugin {
  readonly methods: IAddCountryPluginMethods;

  constructor() {
    this.methods = {
      getAddCountrySync: this.getAddCountrySync.bind(this),
    };
  }

  getAddCountrySync(args?: any) {
    return {
      addCountry: addCountryPayoutConfig,
    };
  }
}
